import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { submitForm } from 'store/api/submitForm/submitForm';
import { CreateUserResponse } from 'store/api/types';
import { createUser } from 'store/api/user/userActions';

import { Registration } from './Registration';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onCreateUser: submitForm<CreateUserResponse>(dispatch, createUser),
});

export const RegistrationContainer = withRouter(
  compose(
    connect(
      undefined,
      mapDispatchToProps,
    ),
  )(Registration),
);
